// Semantic control geometry — DESIGN_LANGUAGE.md §3 + §6. Fixed-px sizes
// tokens resolve BEFORE the em-relative spacing sequence (scratch
// sequence.js getSequenceValue), so radii and control heights stay stable
// regardless of the element's own fontSize — the trap that broke the
// Bellforge control scale. Mirrored in brand designSystem/sizes.js.
export default {
  radiusControl: '12px',
  radiusCard: '17px',
  radiusSheet: '24px',
  radiusPill: '999px',
  controlH: '44px',
  controlHCompact: '36px',

  // THE TOUCH FIELD TEXT FLOOR (DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1): iOS
  // Safari zooms the page when a focused input / textarea / select computes
  // a font-size under 16px. A device-physical threshold, so a fixed px: the
  // field kit's archetypes (AppField.js) take it under '@coarse', where the
  // em-based type scale put them at 12.8-15.4px (measured on dev DFI).
  fieldTextTouch: '16px',

  // THE GLYPH PLATE (dropdowns spec 2026-09-30 §4): the square that holds a workspace glyph — 48 for a
  // launcher tile (a 32 px glyph), 32 for a menu row, 24 for a chip / tab; the orange 'you are here' dot.
  glyphPlate: '48px',
  glyphPlateSm: '32px',
  glyphPlateXs: '24px',
  glyphDot: '8px'

  // The white-label overlay geometry (overlaySm/Md/Lg/Xl, overlayGutter,
  // grabberW/H) was staged here until brand 3.14.798 shipped it (lane D1);
  // its home is brand designSystem/sizes.js. __tests__/stagedOverlayTokens
  // .test.js now locks BRAND to the contract and keeps this file from
  // re-forking it.
}
